// packages/web/src/api/invite.ts
/**
 * Invite API client — invite code + records + quota.
 *
 * 19BN Phase D D2: consolidates the raw fetch in invite-panel.tsx. Read-only;
 * 401 returns null (panel shows its loading fallback for anonymous users).
 *
 * Spec: docs/architecture/account-system-design.md §2.5, §7.2
 */

import { INGEST_URL, IngestApiError } from '../lib/api-client.js';
import type { IngestErrorResponse } from '../lib/api-client.js';

export interface InviteRecord {
  id: string;
  invitee_email: string;
  status: string;
  created_at: number;
  rewarded_at?: number | null;
}

export interface InviteData {
  inviteCode: string;
  invitedBy: string | null;
  quotaUsed: number;
  quotaTotal: number;
  records: InviteRecord[];
}

async function getInvite<T>(path: string): Promise<T | null> {
  const res = await fetch(`${INGEST_URL}${path}`, {
    method: 'GET',
    credentials: 'include',
  });
  if (res.status === 401) return null;
  if (!res.ok) {
    const json = await res.json().catch(() => ({ error: 'unknown' }) as IngestErrorResponse);
    throw new IngestApiError(res.status, json);
  }
  return res.json();
}

export const inviteApi = {
  /** Fetch the current user's invite code + monthly records + quota. Null on 401. */
  get: () => getInvite<InviteData>('/account/invite'),
};
